import {getTheme, ITheme, Panel, PanelType} from '@fluentui/react';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import SplitPane, {Pane} from 'react-split-pane';
import history from '../../history';
import {messageService} from '../../services/messageService';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {getContractingUnit, getProject} from '../../shared/util';
import '../style/style.css';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import DocumentPane from './documentPane/container';
import DocumentPaneSection from '../../shared/mainUI/documentPaneSection/documentPaneSection';
import withMainUI from '../../shared/mainUI/withMainUI';
import ListPane from './listPane/container';
import ListPaneSection from '../../shared/mainUI/listPaneSection/component';
import ShortCutPane from './shortCutPane/container';
import {BookMarkItem} from '../../types/template';
// ---------- for get quality list ------------------ //
import {clearFormData, deleteProduct, filterQualityListPaneData, readByQualityId,} from '../../reducers/qualityReducer';
import {formData, Quality, QualityListItem, QualityListPaneFilter, QualityShortCutPaneItem,} from '../../types/quality';
import i18n from '../../../i18n';
import {resizerStyle} from "../../shared/customStyle/commonStyles";

export interface State {
  selectedShortCutItem: QualityShortCutPaneItem;
  filter: QualityListPaneFilter;
  formData: Quality;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean;
  resetLayout: boolean;
  collapseBookmarkPane: boolean;
  reSizer: number;
  projectId: null | string;
  hiddenRemoveDialog: boolean;
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  showProgressBar: boolean;
  shortCutPaneFilters: QualityShortCutPaneItem[];
  listPaneItem: QualityListItem[];
  formData: Quality;
  setUid: () => void;
  clearUid: () => void;
  resetIsChange: () => void;
  uid: string | null;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
  loading: boolean;
  handleShowDocumentPane: (collapseBookmarkPane?: boolean) => void;
  reSizer: number;
  showDetails: boolean;
  showPanel: boolean;
  handleScroll: () => void;
  currentActiveSection: string;
  animation: any;
  // readQualityShortCutPaneData: () => void;
  filterQualityListPaneData: (filter: QualityListPaneFilter) => void;
  readQualityDropDownData: () => void;
  readByQualityId: (id: string) => void;
  clearFormData: () => void;
  shortcutPaneData: QualityShortCutPaneItem[];

  qlList: QualityListItem[];
  isQLListLoaded: boolean;
  qlDropDowns: any;
  reloadListPane: boolean;
  collapseBookmarkPane: boolean;

  deleteProduct: (idList: [] | string[]) => void;
}

class QualityMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  theme: ITheme = getTheme();
  subscription: any;

  bookmarkList: BookMarkItem[] = [
    {
      id: 1,
      link: 'header',
      label: this.props.t('qualityHeader'),
    },
    {
      id: 2,
      link: 'quality-details',
      label: this.props.t('qualityDetails'),
    },
    { id: 3, link: 'history', label: this.props.t('history') },
  ];

  constructor(props: Props) {
    super(props);

    this.state = {
      filter: new QualityListPaneFilter(),
      selectedShortCutItem: {
        key: null,
        id: null,
        name: null,
        type: null,
        value: null,
        // sequenceCode:null,
      },
      isEdit: false,
      autoSave: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      activeClass: 'grid-righter column-filter-activated',
      bookmarkDivClass: 'bookmark-panel parent',
      showDetails: false,
      formData: formData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: screen.width,
      projectId: null,
      hiddenRemoveDialog: true,
    };
  }

  componentDidMount() {
    this.handleUrlChange();
    // this.props.readQualityDropDownData();
    this.props.filterQualityListPaneData(new QualityListPaneFilter());

    if (
      location.pathname.split('/').pop() === 'new' &&
      this.state.formData &&
      this.state.formData.id === null
    ) {
      this.createNew();
    }
    this.setState(
      {
        formData: this.props.formData,
      },
      this.props.handleShowDocumentPane,
    );
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }

        if (data.data.isNewQL) {
          this.createNew();
        }

        if (data.data.collapseDocumentPane) {
          this.setState({
            reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
            isDrag: !this.state.isDrag,
            collapseBookmarkPane: !this.state.collapseBookmarkPane,
            resetLayout: !this.state.resetLayout,
          });
        }

        if (
          data &&
          data.data &&
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: true });
        } else if (
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          !data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: false });
        }
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      this.props.reloadListPane !== prevProps.reloadListPane &&
      this.props.reloadListPane
    ) {
      this.reloadListPaneItem();
    }
    if (this.props.match.url !== prevProps.match.url) {
      this.handleUrlChange(prevState.collapseBookmarkPane);
    }
    if (this.props.formData !== prevProps.formData) {
      this.setState({
        formData: this.props.formData,
      });
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.state.filter != this.props.location.state.qlFilter
    ) {
      if (this.props.location.state.qlFilter) {
        this.setState(
          {
            filter: this.props.location.state.qlFilter,
          },
          this.reloadListPaneItem,
        );
      }
    }
    if (this.props.collapseBookmarkPane !== prevProps.collapseBookmarkPane) {
      this.setState({
        collapseBookmarkPane: this.props.collapseBookmarkPane,
      });
    }
  }

  handleUrlChange(collapseBookmarkPane?: boolean) {
    let id = this.props.match.params.featureId
      ? this.props.match.params.featureId
      : null;
    let isNew = location.pathname.split('/').pop() === 'new';

    if (id && id !== 'new') {
      this.setState(
        {
          isEdit: !!this.props.match.params.featureid,
          isDisableNewButton: id ? true : false,

          isDrag: false,
          resetLayout: collapseBookmarkPane ? false : true,
          collapseBookmarkPane: collapseBookmarkPane ? true : false,
        },
        () => {
          this.props.handleShowDocumentPane(collapseBookmarkPane);
        },
      );
      this.props.readByQualityId(id);
    } else {
      this.setState(
        {
          isEdit: false,
          isDisableNewButton: false,
          isDrag: false,
          resetLayout: true,
          collapseBookmarkPane: false,
          reSizer: isNew ? screen.width / 2 : screen.width,
        },
        () => {
          this.props.handleShowDocumentPane();
        },
      );
    }
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  // ---------- for get quality list ------------------ //
  filterQualityListPaneData = () => {
    this.props.filterQualityListPaneData(this.state.filter);
  };
  createNew = (): void => {
    this.props.clearFormData();
    //this.props.setUid();
    let formData: any = {
      title: null,
      // ....
    };
    this.setState({
      formData: formData,
    });
    history.push(
      `/CU/${getContractingUnit()}/project/${getProject()}/quality/new`,
    );
  };

  reloadListPaneItem = () => {
    //this.props.resetIsChange();

    // ---------- for get quality list ------------------ //
    //this.props.resetIsChange();
    setTimeout(() => {
      this.filterQualityListPaneData();
    }, 100);

    //for get list pane data PBS

    //  this.props.resetIsChange();
    //  setTimeout(()=>{
    //    this.getListPaneData();
    //  },100)
  };

  renderShortCutPane = () => {
    return (
      <ShortCutPane
        projectId={this.state.projectId}
        shortCutPaneFilters={this.props.shortcutPaneData}
        filter={this.state.filter}
        handelShortCutPaneFilter={(selectedItem: QualityShortCutPaneItem) =>
          this.handelShortCutPaneFilter(selectedItem)
        }
        toggleOverlay={this.state.collapseBookmarkPane}
        resetLayout={this.state.resetLayout}
        isExpand={false}
      />
    );
  };

  getDocumentPaneView = () => {
    return (
      <DocumentPaneSection
        collapseBookmarkPane={this.state.collapseBookmarkPane}
        showProgress={this.props.showProgressBar}
        handleScroll={this.props.handleScroll}
        isEdit={this.props.isEdit}
        formData={this.state.formData}
        bookmarkList={this.bookmarkList}
        currentActiveSection={this.props.currentActiveSection}
        renderCommandBar={() => <CommandBarRight/>}
      >
        <DocumentPane formData={this.props.formData}/>
      </DocumentPaneSection>
    );
  };

  private getListPaneView = () => {
    return (
      <ListPaneSection
        activeClass={this.state.activeClass}
        titlePaneHeader={
          this.state.selectedShortCutItem &&
          this.state.selectedShortCutItem.name
            ? this.state.selectedShortCutItem.name!!
            : i18n.t('all')
        }
        showProgress={this.props.showProgressBar}
        renderCommandBar={() => <CommandBarLeft disable={false}/>}
        renderShotcutPane={() => this.renderShortCutPane()}
      >
        <ListPane
          projectId={this.state.projectId}
          loadMsg={this.props.loadMsg}
          //resourceTypes={this.props.resourceTypeFilter}
          reloadListPaneItem={() => this.reloadListPaneItem()}
          filter={this.state.filter}
          listPaneItems={this.props.listPaneItem} // get data to listPane
          isDataLoaded={this.props.isQLListLoaded}
          isChange={this.props.isChange}
          formData={this.state.formData}
          // handelFilter={(filter:FilterItem)=>this.handelFilter(filter)}       // get data to listPane
          handelFilter={(filter: QualityListPaneFilter) =>
            this.handleFilter(filter)
          }
          handleSelectedListPaneItem={(selectedListItemIds: [] | string[]) => {
            //this.handleSelectedListPaneItem(selectedListItemIds)
          }}
          reSizer={this.state.reSizer}
          selectedShortCutItem={this.state.selectedShortCutItem}
        />
      </ListPaneSection>
    );
  };

  handleFilter = (filter: QualityListPaneFilter) => {
    if ((filter.title && filter.title.length >= 3) || filter.title === null) {
      this.setState(
        {
          filter: filter,
        },
        this.reloadListPaneItem,
      );
    } else {
      this.setState({
        filter: filter,
      });
    }
  };

  handelShortCutPaneFilter = (selectedItem: QualityShortCutPaneItem) => {
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={screen.width / 2}
            defaultSize={
              this.props.showDetails ? screen.width / 2 : screen.width
            }
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.props.reSizer}
            onDragStarted={() => {
              this.setState({
                isDrag: true,
                collapseBookmarkPane: true,
                // resetLayout:false,
              });
            }}
            onResizerDoubleClick={() => {
              this.setState({
                reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
                isDrag: !this.state.isDrag,
                collapseBookmarkPane: !this.state.collapseBookmarkPane,
                resetLayout: !this.state.resetLayout,
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: newSize < screen.width / 2,
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === screen.width / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>{this.getListPaneView()}</Pane>
            <Pane className={'SplitPane'}>
              {this.props.showDetails && (
                <div
                  className={`${this.props.animation(this.props.showDetails)}`}
                  style={{
                    display: this.props.showDetails ? 'block' : 'none',
                    transition: ' 0.9s linear',
                  }}
                >
                  {!this.props.showPanel && (
                    <div>{this.getDocumentPaneView()}</div>
                  )}
                </div>
              )}
            </Pane>
          </SplitPane>
        </div>
        <Panel
          isOpen={this.props.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('corporateProductCatalogue')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.getDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={this.state.hiddenRemoveDialog}
          title={t('areyousure')}
          subText={t('You won\'t be able to revert this!')}
          onClickConfirmDialog={this.onRemoveConfirm}
          onClickCancelDialog={this.onRemoveCancel}
          cancelButtonText={t('No, I won\'t!')}
          confirmButtonText={t('Yes, delete it!')}
        />
      </div>
    );
  }

  //----For Deleate quality------//

  private _handleRemove = () => {
    this.setState({
      hiddenRemoveDialog: false,
    });
  };

  private onRemoveConfirm = () => {
    this.setState({
      hiddenRemoveDialog: true,
    });
    if (this.state.formData.sequenceCode && this.state.formData.id) {
      this.props.deleteProduct([this.state.formData.id]);
      this.createNew();
      if (getContractingUnit()) {
        history.push(
          `/CU/${getContractingUnit()}/project/${getProject()}/quality`,
        );
      } else {
        history.push(`/project/${this.state.projectId}/product/quality/new`);
      }
    }
  };

  private onRemoveCancel = () => {
    this.setState({
      hiddenRemoveDialog: true,
    });
  };

  //what panel?
  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    history.push(`/projects/project/${this.state.projectId}/quality`);
  };

  private hideDocumentPane = () => {
    if (getContractingUnit()) {
      history.push(
        `/CU/${getContractingUnit()}/project/${getProject()}/quality`,
      );
    } else {
      history.push(`/project/${this.state.projectId}/quality`);
    }
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortcutPaneData: state.ql?.qlShortCutPaneData,
    listPaneItem: state.ql.listPaneItem,
    isQLListLoaded: state.ql.isDataLoaded,
    qlList: state.ql.qlList,
    qlDropDowns: state.ql.qlDropDowns,
    reloadListPane: state.ql.reloadListPane,
    formData: state.ql.formData,
    isEdit: state.ql.isEdit,
    showProgressBar: state.ql.showProgressBar,
  };
};

const mapDispatchToProps = {
  // readQualityShortCutPaneData,
  filterQualityListPaneData,
  deleteProduct,
  // readQualityDropDownData,
  readByQualityId,
  clearFormData,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(withMainUI(QualityMainLayout))),
);
